export const updateSquaresState = (posX, posY, id) => ({
    type: 'SQUARES_STATE',
    posX: posX,
    posY: posY,
    id: id
});

export const setSquaresHash = hash => ({
    type: 'SET_SQUARES_HASH',
    hash: hash
});

export const setSquaresDataWithHash = mata => ({
    type: 'SET_SQUARES_DATA_WITH_HASH',
    mata: mata
});

export const clearSquaresData = mata => ({
    type: 'CLEAR_SQUARES_DATA',
    mata: mata
});

export const updateCommands = (posX, posY, id) => ({
    type: 'UPDATE_COMMANDS',
    posX: posX,
    posY: posY,
    id: id
});

export const clearCommands = () => ({
    type: 'CLEAR_COMMANDS'
});


const initialState = {
    hash: '',
    type: 'squares',
    data: [
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
    ],
    commands: [
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
    ]
};

const startingData = [
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
];

const startingCommands = [
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
];

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'SQUARES_STATE':
            if (action.id && !isNaN(action.posX)) {
                if (state.data[action.posX][action.posY] === action.id) {
                    state.data[action.posX][action.posY] = 'aj'
                }
                else state.data[action.posX][action.posY] = action.id;
            }
            return Object.assign({...state});

        case 'SET_SQUARES_HASH':
            state.hash = action.hash;
            break;
        case 'SET_SQUARES_DATA_WITH_HASH':
            return state = Object.assign({}, action.mata.mata);
        case 'CLEAR_SQUARES_DATA':
            return Object.assign({
                data: startingData.map(e => e.concat([])),
                hash: action.mata.hash,
                type: action.mata.type,
                commands: state.commands
            });
        case 'UPDATE_COMMANDS':
            if (state.commands[action.posX][action.posY] === action.id) {
                state.commands[action.posX][action.posY] = startingCommands[action.posX][action.posY]
            }
            else state.commands[action.posX][action.posY] = action.id;
            return state;
        case 'CLEAR_COMMANDS':
            state.commands = startingCommands;
            return Object.assign({
                data: state.data,
                hash: state.hash,
                type: state.type,
                commands: startingCommands
            });
        default:
            return state;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/tableSquaresState.js